<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		:max-width="maxWidth"
		persistent
	>
		<v-alert
			class="mb-0 px-6"
			border="top"
			colored-border
			color="#81CC00"
		>
			<div class="task-title">
				<div class="title-text">Autotimer</div>
				<v-icon @click.stop="$emit('close')">mdi-close</v-icon>
			</div>
			<div class="my-5 link-text">
				Timing
				<span class="under-line-text" @click.stop="onTaskLikeClick()">{{ taskTitle }}&nbsp;for&nbsp;{{ jobCode }}&nbsp;{{ jobName }}</span>
			</div>
			<v-btn block depressed color="#F45252" class="white--text text-capitalize" @click="onStopTimer()">
				<span class="mr-2">{{ time_text }}</span>
				<span>Stop Timer</span>				 
			</v-btn>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'AutoTimerDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		taskTitle: {
			type: String,
			default: ''
		},
		jobCode: {
			type: String,
			default: ''
		},
		jobName: {
			type: String,
			default: ''
		},
		taskId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			time_text: '',
			isActive: true,
		}
	},
	created() {
		this.getTime();
	},
	methods: {
		getTime() {
			const new_time = new Date().getTime();
			const time_passed_in_ms = new_time - this.$store.state.recording.started;
			const time_passed_in_mins = Math.round(time_passed_in_ms / 60000.0);
			this.total_time = time_passed_in_mins;			

			const hours_passed = Math.floor(time_passed_in_mins / 60.0);
			const minutes_passed = time_passed_in_mins - (hours_passed * 60);

			this.time_text = `${hours_passed}h ${minutes_passed}m`;
		},
		onStopTimer() {
			if (this.total_time === 0) {
				this.$store.dispatch('stop_recording');
			} else {
				this.$emit('stop-timer', this.total_time);
			}
			
			this.$emit('close');
		},
		onTaskLikeClick() { 			
			this.$emit('close', this.taskId);
		}
	}
}
</script>
<style lang="scss" scoped>
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.link-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.5px;
	color: #000000;
	
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.under-line-text {
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}

::v-deep {
	.v-alert__content {
		width: 100%;
	}
}
</style>